module.exports = __webpack_public_path__ + ".htaccess.bin";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=[name].[ext]!./app/.htaccess
// module id = ./node_modules/file-loader/dist/cjs.js?name=[name].[ext]!./app/.htaccess
// module chunks = 10